import { ICampaign } from "@/interfaces/campaign.interface";
import { CampaignsMessages } from "@/messages/campaigns/campaigns.messages";
import { CampaignStatus, CampaignType } from "@/types/campaign.types";
import { FilterAttributes, FilterType, FilterValue, IFilter } from "@/types/filter.types";
import { SelectData } from "@/types/form.types";

export type CampaignFilterKey = keyof ICampaign | "all";

export const CAMPAIGNS_TABLE_COLUMNS = (messages: CampaignsMessages) => [
  messages.campaignCodeColumn,
  messages.campaignNameColumn,
  messages.campaignTypeColumn,
  messages.startValidityDateColumn,
  messages.endValidityDateColumn,
  messages.statusColumn,
  messages.optionsColumn,
];

export const FILTER_OPTIONS = (messages: CampaignsMessages): SelectData<CampaignFilterKey>[] => [
  { label: messages.allOption, value: "all" },
  { label: messages.campaignCodeColumn, value: "code" },
  { label: messages.campaignNameColumn, value: "name" },
  { label: messages.campaignTypeColumn, value: "type" },
  { label: messages.startValidityDateColumn, value: "startDate" },
  { label: messages.endValidityDateColumn, value: "endDate" },
  { label: messages.statusColumn, value: "status" },
];

export const FILTER_ATTRIBUTES: Partial<Record<CampaignFilterKey, FilterAttributes>> = {
  all: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "disable",
  },
  code: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
  name: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
  status: {
    defaultValue: "",
    type: FilterType.Equals,
    valueType: "options",
  },
  type: {
    defaultValue: "",
    type: FilterType.Equals,
    valueType: "options",
  },
  startDate: {
    defaultValue: "",
    type: FilterType.GreaterThan,
    valueType: "date",
  },
  endDate: {
    defaultValue: "",
    type: FilterType.LessThan,
    valueType: "date",
  },
};

export const FILTER_OPTION_VALUES = (
  messages: CampaignsMessages
): Partial<Record<CampaignFilterKey, SelectData<FilterValue>[]>> => ({
  status: [
    { label: messages.statusActive, value: CampaignStatus.Active },
    { label: messages.statusInactive, value: CampaignStatus.Inactive },
    { label: messages.statusDraft, value: CampaignStatus.Draft },
    { label: messages.statusRejected, value: CampaignStatus.Rejected },
    { label: messages.statusHold, value: CampaignStatus.Hold },
    { label: messages.statusCompleted, value: CampaignStatus.Completed },
  ],
  type: [
    { label: messages.campaignTypePromotionalPrice, value: CampaignType.PromotionalPrice },
    { label: messages.campaignTypeDiscountCoupon, value: CampaignType.DiscountCoupon },
    { label: messages.campaignTypeSimpleMessage, value: CampaignType.SimpleMessage },
  ],
});

export const initialFilterValues: IFilter<ICampaign>[] = [];

export const STATUS = (messages: CampaignsMessages): SelectData<CampaignStatus>[] => {
  return [
    { value: CampaignStatus.Active, label: messages.statusActive },
    { value: CampaignStatus.Draft, label: messages.statusDraft },
    { value: CampaignStatus.Inactive, label: messages.statusInactive },
  ];
};
